import React from "react";
import { IconBaseProps } from "react-icons";

export const SignOutSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
    display="block"
  >
    <path d="M11.346 17.38c0-.352-.128-.703-.401-.961L9.138 14.59h5.056c.748 0 1.332-.61 1.332-1.348 0-.74-.602-1.349-1.332-1.349H9.12l1.806-1.829a1.36 1.36 0 0 0 0-1.92 1.321 1.321 0 0 0-1.897 0L4.923 12.3a1.36 1.36 0 0 0 0 1.92l4.124 4.12c.53.536 1.368.536 1.898 0 .255-.277.401-.628.401-.96z" />
    <path d="M13.526 7.056c0 .738.576 1.315 1.273 1.315h2.163v9.742H14.8c-.715 0-1.273.594-1.273 1.314 0 .72.576 1.315 1.273 1.315h3.454c.715 0 1.273-.595 1.273-1.315V7.057c0-.74-.575-1.315-1.273-1.315h-3.454c-.715 0-1.273.594-1.273 1.314z" />
  </svg>
);
